import React from 'react'

import { Text } from '@chakra-ui/react'
import { Button } from 'src/components/__legacy__/button/button'
import { Message } from 'src/components/__legacy__/message/message'
import { Modal } from 'src/components/__legacy__/modal/modal'
import { ModalActions } from 'src/components/__legacy__/modal/modal-actions'
import { ModalContent } from 'src/components/__legacy__/modal/modal-content'
import { ModalTitle } from 'src/components/__legacy__/modal/modal-title'
import { Spacer } from 'src/components/__legacy__/spacer/spacer'
import { useReplaceMembers } from 'src/legacy_modules/entities/member/atom'
import { fetch as fetchMembers } from 'src/legacy_modules/entities/member/request'
import { useRequestState } from 'src/legacy_modules/server/use-request-state'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'
import styled from 'styled-components'

import { submitDelete } from './request'

type Props = {
  userName: string
  trialUid: string
  memberUid: string
  closeModal: () => void
}

const Bold = styled.span`
  font-weight: bold;
`

export const DisableModal: React.FC<Props> = props => {
  const { userName, trialUid, memberUid, closeModal } = props

  const { request, requesting, errorMessage } = useSubmitDisable()

  const onSubmit = async () => {
    await request({ memberUid, trialUid })
    closeModal()
  }

  return (
    <Modal onClose={closeModal}>
      <ModalTitle title="アカウントを無効にする" />
      <ModalContent>
        <Text textAlign="center">
          <Bold>{userName}</Bold>
          さんのアカウントを無効にします。よろしいですか？
        </Text>
      </ModalContent>

      <ModalActions>
        <Button
          size="S"
          text="キャンセル"
          buttonType="cancel"
          onClick={closeModal}
        ></Button>
        <Spacer size={40} horizontal />
        <Button
          size="S"
          text="無効化"
          buttonType="important"
          onClick={onSubmit}
          disabled={requesting}
        ></Button>
      </ModalActions>
      {errorMessage && <Message type="error" message={errorMessage} centered />}
    </Modal>
  )
}

const useSubmitDisable = () => {
  const {
    requesting,
    errorMessage,
    requestStarted,
    requestDone,
    requestFailed,
  } = useRequestState()
  const replaceMembers = useReplaceMembers()
  const toast = useMirohaToast()

  const request = async ({
    trialUid,
    memberUid,
  }: {
    trialUid: string
    memberUid: string
  }) => {
    try {
      requestStarted()

      await submitDelete({ trialUid, memberUid })
      const members = await fetchMembers({ trialUid, type: 'all' })
      replaceMembers(members)

      toast({ status: 'success', title: 'アカウントを無効化しました' })

      requestDone()
    } catch (error) {
      requestFailed(error.message)
      throw error
    }
  }

  return {
    request,
    requesting,
    errorMessage,
  }
}
